import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import UserDataService from '../../../../services/UserDataService';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { COMMON_LOADING_STATES, PAGE_STATE } from '../../constants/constants';
import { setChangePasswordSuccess, componentKey, setLoadingState } from './ChangePasswordSlice';

export const { changeUserPassword } = {
	changeUserPassword: (payload) => {
		return {
			type: "ACCOUNT/CHANGE_PASSWORD",
			payload: payload
		}
	},
}
function* changeUserPasswordAsync(action) {
	try {
		const { currentPassword, newPassword, confirmPassword } = action.payload;
		yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));

		const response = yield UserDataService.changePassword({ Password: currentPassword, NewPassword: newPassword });

		if (response.data.Status === 0) {

			let keys = Object.keys(response.data.Data);
			for (let key of keys) {
				yield put(addNotifications({
					heading: "Error",
					message: response.data.Data[key].join(""),
					variant: TOASTER_VARIANT.DANGER
				}));
			}
		} else {
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS
			}));
			yield put(setChangePasswordSuccess(true))
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} 
	finally {
		yield put(setLoadingState({ state:  COMMON_LOADING_STATES.GENERAL_READY }))
	}
}

function* rootSaga() {
	yield all([
		takeLatest(changeUserPassword().type, changeUserPasswordAsync),
	]);
}
store.sagaManager.addSaga(componentKey, rootSaga);